import type { GovInfobarProps } from '@gov-design-system-ce/react';
import { GovIcon, GovInfobar } from '@gov-design-system-ce/react';
import { renderIcon } from '@gov-nx/component/common';
import { useAppContext } from '@gov-nx/core/app';
import { useCmsMessageLoader, useGlobalLocale } from '@gov-nx/core/service';
import { filterCmsMessagesByCodes } from '@gov-nx/utils/common';
import { MarkdownRender } from '../Markdown/MarkdownRender';

type CmsMessageContainerProps = {
	type?: GovInfobarProps['type'];
};

export const CmsMessageContainer = ({
	type = 'subtle',
}: CmsMessageContainerProps) => {
	const { currentPageCode, currentServiceCode } = useAppContext();
	const { t } = useGlobalLocale();
	const { messages } = useCmsMessageLoader();

	return (
		<>
			{filterCmsMessagesByCodes(
				messages,
				currentPageCode,
				currentServiceCode
			).map((message) => {
				const icon = message.icon?.icon ? renderIcon(message.icon.icon) : null;
				return (
					<GovInfobar
						icon={
							icon ? (
								<GovIcon
									name={icon.name}
									type={icon.type}
								/>
							) : undefined
						}
						headline={
							message.headline ? (
								<p slot="headline">{message.headline}</p>
							) : undefined
						}
						key={message.id}
						// @TODO: z CMS chodi variat namisto color
						color={message.properties.variant as GovInfobarProps['color']}
						type={type}
						accessibleToggleLabel={t('alert.wcag.toggle-label')}
						accessibleCloseLabel={t('alert.wcag.close-label')}>
						<MarkdownRender>{message.message}</MarkdownRender>
					</GovInfobar>
				);
			})}
		</>
	);
};
